import type { FormFieldConfig, FormFieldOption, FormSubmitValues } from './form-widget.types';

export function getFieldOptions(
  field: FormFieldConfig,
  values: FormSubmitValues,
): FormFieldOption[] {
  if (field.optionsWhen) {
    const controllers = field.optionsWhen.fields ?? (field.optionsWhen.field ? [field.optionsWhen.field] : []);
    const key = controllers
      .map((name) => (typeof values[name] === 'string' ? (values[name] as string) : ''))
      .join('|');
    return field.optionsWhen.options[key] || [];
  }
  return field.options ?? [];
}

export function isFieldVisible(field: FormFieldConfig, values: FormSubmitValues) {
  if (field.visibleWhen) {
    const currentValue = values[field.visibleWhen.field];
    if (!(typeof currentValue === 'string' && field.visibleWhen.values.includes(currentValue))) {
      return false;
    }
  }

  if (field.optionsWhen) {
    return getFieldOptions(field, values).length > 0;
  }

  return true;
}
